// Shared helpers and metadata for the Spare Parts module.

export const UNITS = [
  { key: "nos",    label: "Nos" },
  { key: "set",    label: "Set" },
  { key: "pair",   label: "Pair" },
  { key: "kit",    label: "Kit" },
  { key: "pack",   label: "Pack" },
  { key: "litre",  label: "Litre" },
  { key: "ml",     label: "ml" },
  { key: "kg",     label: "Kg" },
  { key: "g",      label: "g" },
  { key: "m",      label: "Metre" },
];

export const CATEGORIES = [
  "Engine", "Filters", "Lubricants", "Brakes", "Suspension", "Steering",
  "Clutch", "Transmission", "Electrical", "Battery", "AC", "Cooling",
  "Fuel System", "Exhaust", "Body Parts", "Lights", "Glass", "Wipers",
  "Tyres", "Wheel Components", "Consumables", "Accessories", "Other",
];

export const STATUS_META = {
  in_stock:      { label: "In Stock",     chip: "bg-[#12B76A]/12 text-[#0F9256]", dot: "#12B76A" },
  low_stock:     { label: "Low Stock",    chip: "bg-[#FEF0C7] text-[#B54708]",    dot: "#F79009" },
  out_of_stock:  { label: "Out of Stock", chip: "bg-[#e63946]/15 text-[#e63946]", dot: "#e63946" },
  reserved:      { label: "Reserved",     chip: "bg-[#a8dadc]/30 text-[#457b9d]", dot: "#457b9d" },
  inactive:      { label: "Inactive",     chip: "bg-[#98A2B3]/20 text-[#475467]", dot: "#98A2B3" },
};

export const MOVEMENT_META = {
  opening_stock:       { label: "Opening Stock",     accent: "#457b9d" },
  purchase_inward:     { label: "Purchase Inward",   accent: "#12B76A" },
  direct_inward:       { label: "Direct Inward",     accent: "#12B76A" },
  job_card_issue:      { label: "Job Card Issue",    accent: "#e63946" },
  job_card_return:     { label: "Job Card Return",   accent: "#457b9d" },
  counter_sale:        { label: "Counter Sale",      accent: "#e63946" },
  purchase_return:     { label: "Purchase Return",   accent: "#F79009" },
  stock_adjustment:    { label: "Stock Adjustment",  accent: "#F79009" },
  reservation:         { label: "Reservation",       accent: "#98A2B3" },
  reservation_release: { label: "Release",           accent: "#98A2B3" },
};

export const ADJUSTMENT_TYPES = [
  { key: "physical_correction", label: "Physical stock correction" },
  { key: "damaged",             label: "Damaged" },
  { key: "lost",                label: "Lost" },
  { key: "scrap",               label: "Scrap" },
  { key: "excess_found",        label: "Excess found" },
  { key: "opening_balance",     label: "Opening balance" },
  { key: "data_correction",     label: "Data correction" },
  { key: "other",               label: "Other" },
];

export const inr = (n) => {
  if (n === null || n === undefined || Number.isNaN(Number(n))) return "-";
  return `₹${new Intl.NumberFormat("en-IN", { maximumFractionDigits: 0 }).format(Number(n))}`;
};

export const fmtQty = (n, unit = "") => {
  const num = Number(n || 0);
  const s = Number.isInteger(num) ? num.toString() : num.toFixed(2);
  return unit ? `${s} ${unit}` : s;
};
